import { defineRouting } from "next-intl/routing";
import { defaultLocale, locales } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: "always",
  // Prefer the URL / language switcher over Accept-Language redirects,
  // which can fight HMR soft-navigations and look like a refresh loop.
  localeDetection: false,
});
